import dynamic from "next/dynamic";
import SideBySideHubspotFormConfig from "./side-by-side-hubspot-form-config";
import SideBySideHubspotFormAdvancedConfig from "./side-by-side-hubspot-form-advanced-config";
const SideBySideHubspotFormComponent = dynamic(()=>import("./side-by-side-hubspot-form-component"));
export default {
    SideBySideHubspotFormComponent,
    SideBySideHubspotFormConfig,
    SideBySideHubspotFormAdvancedConfig
};
